









import GreenButton from '@/views/atoms/GreenButton.vue'
export default
  components: {
    GreenButton
  }

  props:
    index:
      type: Number
      default: 2

  watch: {
    index: (v) ->
      @selectedIndex = v
  }

  data: () ->
    selectedIndex: 2

  created: () ->
    @selectedIndex = @index

  methods: {
      select_toggle: (index) ->
        @selectedIndex = index
        wk = @_math_date()
        @$emit('click', wk, index)

      _math_date:() ->
        today = new Date()
        thisYear = today.getFullYear()
        thisMonth = today.getMonth()
        date = today.getDate()
        dayNum = today.getDay()
        thisMonday = date - dayNum
        if @selectedIndex == 0
          thisMonday = thisMonday - 14
        else if @selectedIndex == 1
          thisMonday = thisMonday - 7
        else if @selectedIndex == 3
          thisMonday = thisMonday + 7
        else if @selectedIndex == 4
          thisMonday = thisMonday + 14
        thisSunday = thisMonday + 6

        startDate = new Date(thisYear, thisMonth, thisMonday)
        startDate =
            startDate.getFullYear() + "/" +
                ('0' + (startDate.getMonth() + 1)).slice(-2) + "/" +
                    ('0' + startDate.getDate()).slice(-2)

        endDate = new Date(thisYear, thisMonth, thisSunday)
        endDate =
            endDate.getFullYear() + "/" +
                ('0' + (endDate.getMonth() + 1)).slice(-2) + "/" +
                    ('0' + endDate.getDate()).slice(-2)

        return [startDate, endDate]
  }
